import { Box, Button, useBreakpointValue, useToast } from '@chakra-ui/react';
import { copyToClipboard } from 'src/utils/copyToClipboard/copyToClipboard';
import { useCallback } from 'react';
import { useReferralLink } from 'src/utils/useReferralLink';
import { ReferralTabHeader } from '../components';
import { InputCopy } from 'src/components/InputCopy';

export const ReferralLinkTabContent = () => {
  const toastPosition = useBreakpointValue({
    base: 'top-center',
    md: 'bottom-left',
  });
  const toast = useToast({ position: toastPosition });
  const referralLink = useReferralLink();

  const handleCopyLink = useCallback(() => {
    copyToClipboard(referralLink);
    toast({
      title: 'Link copiado',
      status: 'success',
    });
  }, [referralLink, toast]);

  return (
    <Box textAlign="start">
      <ReferralTabHeader
        title="Indique clientes por link e garanta 0% de taxa de comissão*** para novos
        lojistas"
        subtitle="Copie seu link exclusivo clicando no botão abaixo e divulgue sua loja."
      />

      <InputCopy value={referralLink} copyHandler={handleCopyLink} mb={5} />
      <Button colorScheme="yellow" onClick={handleCopyLink} size="lg">
        Copiar link
      </Button>
    </Box>
  );
};
